import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import {colourStyles, colourStyles2} from '../../../../components/styles/styles'
import {ErrorMessage, Field, useField} from 'formik'
import {
  AnimaDireita2,
  AnimaFadeininput,
} from '../../../../../../../../_metronic/assets/animation/styles'
import Select from 'react-select'
import {Link} from 'react-router-dom'

const API_URL = process.env.REACT_APP_API_URL || 'api'

interface UseOption {
  readonly value: string
  readonly label: string
  readonly uuid?: string
}

const Step1: FC = () => {
  const intl = useIntl()
  const [proid, setProid] = useState<any>(0)

  //Constantes de campos do Formik hook UseField
  const [fieldProject, , helperProject] = useField('project_id')

  const [fieldContractType, ,] = useField('contract_type')
  const [fieldIdentifier, ,] = useField('identifier')
  const [fieldPropertyId, , helperPropertyId] = useField('property_id')
  const [fieldResponsibleID, , helperResponsibleID] = useField('responsible_id')
  // const [fieldObservations, ,] = useField('observations')

  //Constantes guadam o valor do input
  const [selectedProject, setSelectedProject] = useState([])
  const [selectedEntrepreneurID, setSelectedEntrepreneurID] = useState([])
  const [selectedResponsibleID, setSelectedResponsibleID] = useState([])
  const [disableUsers, setDisableUsers] = useState(true)
  const [uuid, setUuid] = useState<any>(0)

  //função de load do select2 de Projetos -- project_id
  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()
      var projects: any = []
      var options: any = []
      let projectIdinit = parseInt(fieldProject.value)

      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const project: any = {
              value: Response[i].id,
              label: Response[i].code,
            }
            projects.push(project)

            if (projectIdinit === Response[i].id) {
              options.push(project)
            }
          }
        }
        setSelectedProject(options[0])
      }
      callback(projects)
    }, 500)
  }

  //função onchange do select2 de Projetos -- project_id
  const handleInputChangeProjects = (event: any) => {
    //limpar o Input dos tipos da Licenças
    setDisableUsers(true)

    setTimeout(() => {
      var inputValue = ''
      inputValue = event.value
      setSelectedProject(event)
      helperProject.setValue(inputValue)
      setProid(inputValue)
      setDisableUsers(false)
      return {inputValue}
    }, 500)
  }

  //função de load do select2 Empreendedor -- entrepreneur_id
  const loadOptionsEntrepreneurs = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getentrepreneur()
      var entrepreneurs: any = []
      var options: any[] = []

      let propertyIdinit = fieldPropertyId.value

      async function getentrepreneur() {
        const {data} = await axios.get(API_URL + '/sgt/v1/properties/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const property: any = {
              value: Response[i].id,
              label: Response[i].name,
              uuid: Response[i].uuid,
            }
            entrepreneurs.push(property)

            if (parseInt(propertyIdinit) === Response[i].id) {
              options.push(property)
            }
          }
        }
        setSelectedEntrepreneurID(options[0])
      }
      callback(entrepreneurs)
    }, 1000)
  }

  //função onchange do select2 Empreendedor -- entrepreneur_id
  const handleInputChangeEntrepreneurIDs = (event: any) => {
    var inputValue = ''
    inputValue = event.value
    setSelectedEntrepreneurID(event)
    helperPropertyId.setValue(inputValue)
    setUuid(event.uuid)
    return {inputValue}
  }
  //função de load do select2 de usuarios responsaveis -- responsible_id
  const loadOptionsResponsibleID = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getUser()
      var units: any = []
      var options: any[] = []

      let responsibleIdinit = fieldResponsibleID.value

      async function getUser() {
        const {data} = await axios.get(API_URL + '/v1/users/select2?sga_project_id=' + proid)
        let Response = data.results

        if (Response.length === 0) {
          setDisableUsers(true)
        }

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const unit: any = {
              value: Response[i].id,
              label: Response[i].username,
            }
            units.push(unit)
            //CONDICIONAL PARA SELECT2 MULTIPLOS
            if (responsibleIdinit) {
              for (var j = 0; j < responsibleIdinit.length; j++) {
                if (parseInt(responsibleIdinit[j]) === Response[i].id) {
                  options.push(unit)
                }
              }
            }
          }
        }
        setSelectedResponsibleID(options as any)
      }
      callback(units)
    }, 1000)
  }

  //função onchange do select2 de usuarios responsaveis -- responsible_id
  const handleInputChangeResponsibleIDs = (event: any) => {
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(event[i].value)
      }
    }
    setSelectedResponsibleID(event)
    helperResponsibleID.setValue(inputValue)
    return {inputValue}
  }

  //INICIO DO HTML
  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder text-dark'>
            {intl.formatMessage({id: 'LICENSES.TITLE_STEAP1'})}
          </h2>
          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'CONTRACTS.SUBTITLE_STEAP1'})}
          </div>
        </div>

        <div className='card-body p-0 '>
          {/* inicio da primeira linha */}
          <div className='row'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.IDENTIFIER'})}
              </label>
              <div className='d-flex align-items-start position-relative my-1'>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid p-1 pl-1 ps-6'
                  placeholder={intl.formatMessage({id: 'CONTRACTS.IDENTIFIER'})}
                  {...fieldIdentifier}
                />
              </div>
            </div>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'PROPERTIES.TITLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <AsyncSelect
                  className='form-control form-control-lg form-control-solid p-1 ps-6'
                  data-kt-license-table-filter='property_id'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsEntrepreneurs}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={intl.formatMessage({id: 'PROPERTIES.TITLE'})}
                  value={selectedEntrepreneurID}
                  onChange={handleInputChangeEntrepreneurIDs}
                />
                {fieldPropertyId.value !== undefined ? (
                  <Link
                    to={`/editproperties/${uuid}`}
                    className='btn btn-sm btn-icon btn-primary p-3 m-2'
                    title='Visualizar Propriedade'
                  >
                    <i className='bi bi-eye-fill fs-2'></i>
                  </Link>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
          {/* fim da primeira linha */}

          {/* inicio da segunda linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'PROJECT.PROJECT_TITLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <AsyncSelect
                  className='form-control form-control-lg form-control-solid p-1  ps-6'
                  data-kt-license-table-filter='project_id'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptionsProjects}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={intl.formatMessage({id: 'PROJECT.PROJECT_TITLE'})}
                  value={selectedProject}
                  onChange={handleInputChangeProjects}
                />
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.TYPE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <select
                  className='form-select form-select-solid ps-6'
                  data-kt-select2='true'
                  {...fieldContractType}
                >
                  <option value='production'>
                    {intl.formatMessage({id: 'CONTRACTS.TYPE_PRODUCTION'})}
                  </option>
                  <option value='servitude'>
                    {intl.formatMessage({id: 'CONTRACTS.TYPE_SERVITUDE'})}
                  </option>
                  <option value='direct_damage'>
                    {intl.formatMessage({id: 'CONTRACTS.TYPE_DIRECT_DAMAGE'})}
                  </option>
                </select>
              </div>
            </div>
          </div>
          {/* fim da segunda linha */}

          {/* inicio da terceira linha */}

          {/* fim da terceira linha */}

          {/* inicio da sexta linha */}
          <div className='row mt-3'>
            <div className='col-lg-12'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'USERS.TITLE'})} Responsáveis
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                {disableUsers ? (
                  <Select
                    className='form-control form-control-lg form-control-solid p-1 text-danger pl-1 ps-6 '
                    styles={colourStyles}
                    isDisabled={disableUsers}
                    placeholder='Selecione um Projeto'
                  />
                ) : (
                  <AnimaFadeininput>
                    <AsyncSelect
                      className='form-control form-control-lg form-control-solid p-1 pl-1'
                      styles={colourStyles}
                      isMulti
                      //components={animatedComponents}
                      cacheOptions
                      loadOptions={loadOptionsResponsibleID}
                      filterOption={(option, inputValue) =>
                        option.label
                          ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                          : false
                      }
                      defaultOptions
                      placeholder={intl.formatMessage({id: 'USERS.TITLE'})}
                      value={selectedResponsibleID}
                      onChange={handleInputChangeResponsibleIDs}
                    />
                  </AnimaFadeininput>
                )}
              </div>
            </div>

            <div className='col-lg-12'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Field
                  as='textarea'
                  name='observations'
                  className='form-control form-control-lg form-control-solid'
                  rows={3}
                ></Field>
                <div className='text-danger mt-2'>
                  <ErrorMessage name='observations' />
                </div>
              </div>
            </div>
          </div>
          {/* fim da sexta linha */}
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step1}
